import React, { useContext, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { AuthContext } from '../../context/Auth/AuthContext';


export function RecaptchaView() {

    const captcha = useRef(null);
    const { updateCaptcha } = useContext(AuthContext);

    const handleChangeCaptcha = () => {
        if (captcha.current.getValue()) {
            updateCaptcha(true);
        } else {
            updateCaptcha(false);
        }
    }


    return (
        <ReCAPTCHA
            ref={captcha}
            sitekey="6Ld9MlchAAAAAA0nL2GYS9lTozXuyjkkruFP9drF"
            onChange={handleChangeCaptcha}
        />
    )

}